import * as angular from 'angular';
import 'angular-ui-router';
import ApplicationModel from './ApplicationModel';
import { ApplicationService2 } from './ApplicationService2';
import TalkService from './TalkService';
import { AdminService } from './misc/AdminService';
import { BucketService } from './misc/BucketService';
import { ChatbotSettingsService } from './misc/ChatbotSettingsService';
import { DiscourseValidationService } from './misc/DiscourseValidationService';
import { GatewayStateConfigurationsService } from './misc/GatewayStateConfigurationsService';
import { HostingService } from './misc/HostingService';
import { MarketplaceTemplatesService } from 'modules/application/MarketplaceTemplatesService';
import { MenuItemsService } from './misc/MenuItemsService';
import { SegmentService } from './misc/SegmentService';
import { UndoRedoService } from './misc/UndoRedoService';
import { SharedToastsService } from './misc/SharedToastsService';
import { CreateApplicationService } from 'modules/application/create/CreateApplicationService';
import { AiAgentService } from './misc/AiAgentService';
import { CopilotService } from './misc/CopilotService';
import { applicationCreate } from './create';
import applicationDetail from './detail';
import applicationList from './list';
import { CallerConfigurationService } from './misc/CallerConfigurationService';
import contact from 'modules/contact';
import { SentryClient } from 'monitoring-error-handler';
import { ToastService } from './misc/ToastService';
import { tenantModule } from 'modules/application/tenant';
import { ExternalPluginService } from './misc/ExternalPluginService';
import { SortMenuOptionsService } from './misc/SortMenuOptionsService';
import { HubSpotService } from './misc/HubSpotService';
import { SecretService } from './misc/SecretService';
import AiAgentView from './detail/aiAgents/AiAgentsView.html';
import { MicroFrontendService } from 'modules/shared/MicroFrontendService';
import { aiAgentsScriptSource, blipStatusScriptSource, transcriptionScriptSource } from 'app.constants';
import { AiAgentsUnattachedController } from './detail/aiAgents/AiAgentsUnattachedController';
import { aiAgentsCreateStateName, aiAgentsDiscoveryStateName } from './create/steps/aiAgent';
import { ArtificialIntellingeceConfigurationsService } from './misc/ArtificialIntellingeceFeatureConfigurations';
import { FunctionService } from './misc/FunctionService';
import productUpdates from './productUpdates';
export default angular
    .module('application', [
    'ui.router',
    'ngResource',
    contact,
    applicationCreate,
    applicationDetail,
    applicationList,
    tenantModule,
    productUpdates,
])
    .constant('ApplicationModel', ApplicationModel)
    .service('ApplicationService2', ApplicationService2)
    .service('AiAgentService', AiAgentService)
    .service('CopilotService', CopilotService)
    .service('CreateApplicationService', CreateApplicationService)
    .service('AdminService', AdminService)
    .service('TalkService', TalkService)
    .service('ToastService', ToastService)
    .service('BucketService', BucketService)
    .service('SecretService', SecretService)
    .service('FunctionService', FunctionService)
    .service('ChatbotSettingsService', ChatbotSettingsService)
    .service('GatewayStateConfigurationsService', GatewayStateConfigurationsService)
    .service('HostingService', HostingService)
    .service('MarketplaceTemplatesService', MarketplaceTemplatesService)
    .service('MenuItemsService', MenuItemsService)
    .service('DiscourseValidationService', DiscourseValidationService)
    .service('CallerConfigurationService', CallerConfigurationService)
    .service('ArtificialIntellingeceConfigurationsService', ArtificialIntellingeceConfigurationsService)
    .service('SegmentService', SegmentService)
    .service('HubSpotService', HubSpotService)
    .service('UndoRedoService', UndoRedoService)
    .service('ExternalPluginService', ExternalPluginService)
    .service('SortMenuOptionsService', SortMenuOptionsService)
    .service('SharedToastsService', SharedToastsService)
    .run(function () {
    MicroFrontendService.addSource(aiAgentsScriptSource);
    MicroFrontendService.addSource(blipStatusScriptSource);
    MicroFrontendService.addSource(transcriptionScriptSource);
})
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('auth.application', {
            abstract: true,
            template: '<ui-view></ui-view>',
            resolve: {
                isUserInitialized: ['AccountService2', 'InitializeUserService', async function (AccountService2, InitializeUserService) {
                        const me = await AccountService2.me();
                        await InitializeUserService.initFeatureToggle();
                        // Identify user to track errors
                        SentryClient.identifyUser({
                            email: me.email,
                            id: me.identity.toString(),
                        });
                    }],
            },
        })
            .state('auth.application.aiAgents', {
            abstract: true,
        })
            .state(aiAgentsDiscoveryStateName, {
            url: '/application/ai-agents/about',
            views: {
                '@auth.application': {
                    controller: AiAgentsUnattachedController,
                    controllerAs: '$ctrl',
                    template: AiAgentView,
                },
            },
        })
            .state(aiAgentsCreateStateName, {
            url: '/application/ai-agents/create',
            views: {
                '@auth.application': {
                    controller: AiAgentsUnattachedController,
                    controllerAs: '$ctrl',
                    template: AiAgentView,
                },
            },
        });
    }]).name;
